import { ZfPill, ZfStack, ZfTextButton, ZfTypography } from '@zafire/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useYwuApp } from '../../../contexts/ywu-app-context';
import type { IDndItem } from '../../../interfaces/dnd';
import { isTranslation } from '../../../interfaces/generic';
import { Dnd } from './Dnd';

interface IProps<TItem> {
    title: string;
    selectedItems: (IDndItem & TItem)[];
    allItems: (IDndItem & TItem)[];
    onChange: (payload: (IDndItem & TItem)[]) => void;
}

export const ListEditorDnd = <TItem extends IDndItem>({ title, selectedItems, allItems, onChange }: IProps<TItem>) => {
    const { i18n, t } = useTranslation();
    const { activeLanguage } = useYwuApp();
    const [isEditMode, setEditMode] = useState(false);

    const onEditListClick = () => setEditMode(true);
    const filterItems = (item: IDndItem, searchTerm: string) =>
        (typeof item.name === 'string' ? item.name : item.name[activeLanguage]).toLowerCase().includes(searchTerm);

    const itemRenderFn = (item: IDndItem) => (isTranslation(item.name) ? item.name[i18n.language] : item.name);

    return (
        <ZfStack direction="column" spacing="small">
            <ZfTypography variant="label-large" weight="bold">
                {title}
            </ZfTypography>
            {isEditMode ? (
                <Dnd
                    allItems={allItems}
                    selectedItems={selectedItems}
                    onItemsChange={onChange}
                    filterFn={filterItems}
                    sortAvailableItems={true}
                    itemRenderFn={itemRenderFn}
                />
            ) : (
                <ZfStack direction="column" spacing="small">
                    {selectedItems.length ? (
                        <ZfStack direction="row" spacing="small">
                            {selectedItems.map((item) => (
                                <ZfPill key={item.id} color="info" clickable={false}>
                                    {itemRenderFn(item)}
                                </ZfPill>
                            ))}
                        </ZfStack>
                    ) : (
                        t('contentAdmin.noItemsConfigured')
                    )}
                    <ZfTextButton onClick={onEditListClick} hierarchy="secondary" size="small" style={{ alignSelf: 'start', marginTop: '8px' }}>
                        {t('contentAdmin.editButton')}
                    </ZfTextButton>
                </ZfStack>
            )}
        </ZfStack>
    );
};
